<template>
  <div class="page-content">
    <tabs :tabs="certInfo" :active-index="activeIndex" @changeTab="changeTab" />
    <div class="container-page">
      <div class="report-container">
        <keep-alive>
          <component
            :is="currFileType"
            :active-index="activeIndex"
            :cert-info="certInfo"
          ></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import Hammer from 'hammerjs'
import { navBar } from '@/utils/native_interactions/native_bar'
import Tabs from './widget/Tabs'
import ContentPdf from './widget/ContentPdf'
import ContentPng from './widget/ContentPng'
import { API } from '@/api'
import { DialogAlert } from '@/utils/dialog.js'
import { APP_CONFIG } from '@/defines/environment/config'

export default {
  components: {
    Tabs,
    ContentPdf,
    ContentPng
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = `${APP_CONFIG.app_short_name}商品检测报告`
      navBar.setTitle({
        text: title
      })
      document.title = title
      if (!vm.$route?.query?.sku_id) {
        return DialogAlert('缺少参数sku_id')
      }
      const skuId = vm.$route.query.sku_id
      vm.getCertInfo(skuId)
    })
  },
  data() {
    return {
      activeIndex: 0,
      safePaddingBottom: true,
      certInfo: []
    }
  },
  computed: {
    currentTabReport() {
      if (!this.certInfo) return
      const obj = this.certInfo[this.activeIndex]
      return obj ? obj.cert || [] : []
    },
    currFileType() {
      if (!this.certInfo) return
      const obj = this.certInfo[this.activeIndex]
      return obj && obj.fileType === 'pdf' ? 'content-pdf' : 'content-png'
    }
  },

  mounted() {
    this.$nextTick(() => {
      const container = document.querySelector('.report-container')
      const manager = new Hammer.Manager(container)
      // Create a recognizer
      var DoubleTap = new Hammer.Tap({
        event: 'doubletap',
        taps: 2
      })

      manager.add(DoubleTap)
      // console.log('manager', manager)

      // Subscribe to desired event
      manager.on('doubletap', function (e) {
        container.classList.toggle('expand') // e.target
      })
    })
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index
    },
    async getCertInfo(skuId) {
      try {
        const resData = await API.inspectReport.getSkuCertInfo({
          sku_id: skuId
        })
        this.certInfo = resData?.cert_list || []
      } catch (e) {
        this.certInfo = []
        if (Number(e?.res?.error?.code === 2006001)) {
          DialogAlert(e?.res?.error?.msg)
        } else {
          this.$toast({
            message: e?.res?.error?.msg || '操作失败，请稍候重试',
            duration: 1000
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-content {
  display: flex;

  position: relative;

  height: 100vh;

  background-color: #fff;

  flex-direction: column;
}

.container-page {
  overflow: auto;

  flex: 1;
}
.report-container {
  width: 100%;

  transition: transform 300ms ease-out;
}

.expand {
  transform: scale(2);
  transform-origin: 0 0;
}
</style>
